@if (!!activeMembership && !!activeEmployment && employments?.length > 1) {
  <button tid="employment-menu-button" [matMenuTriggerFor]="employmentMenu" class="menu-trigger" tabindex="0" #menuTrigger>
    <span>{{ activeMembership.organisationName }}</span>
    <i class="ph-light ph-caret-down"></i>
  </button>
  <mat-menu #employmentMenu tid="employment-menu" class="employment-menu context-menu">
    @for (employment of employments; track employment) {
      <button
        mat-menu-item
        (click)="select(employment)"
        [attr.data-employment-id]="employment.myEmploymentModel.employmentId"
        [attr.data-organisation-id]="employment.myEmploymentModel.organisationGuid"
        [attr.data-employee-id]="employment.myEmploymentModel.id"
        tabindex="0"
      >
        <span class="employment">
          <app-body class="organisation" [semiBold]="true" tid="employment-selector-employer">{{ employment.organisationName }}</app-body>
          <app-body-xs class="period" [semiBold]="true">{{ getEmploymentPeriod(employment.myEmploymentModel) }}</app-body-xs>
        </span>
        <app-body-xs [semiBold]="true" tid="employment-selector-employer">{{ employment.myEmploymentModel.employer.name }} </app-body-xs>
      </button>
    }
    @if (!employments.length) {
      <app-body-md [bold]="true" id="no-results">No employments found</app-body-md>
    }
  </mat-menu>
}

@if (!!activeMembership && employments?.length === 1) {
  <div class="selected-label" tid="single-employment-organisation-label">
    <span>{{ activeMembership.organisationName }}</span>
  </div>
}
